module.exports = __webpack_public_path__ + "img/电热水瓶.00632ac4.png";